<style lang="scss" scoped>
.upgrade {
	margin-bottom: 40px;
	margin-top: -2px;
	z-index: 248;
	position: sticky;
	cursor: pointer;
	&__title {
		font-weight: 600;
		text-align: center;
		opacity: 0.8;
	}
}
</style>

<template lang="pug">
    .upgrade.alert.alert-warning(v-if="shouldShow")
        router-link(tag="div", :to="{ name : 'thirdparty.scholarpack' }").upgrade__title {{ $t('upgrade-notice.title') }}
</template>

<script>
import gql from "graphql-tag";

export default {
	data() {
		return {
			shouldShow: false
		};
	},
	apollo: {
		School: {
			query: gql`
				{
					User {
						id
						School {
							id
							mis_identity
						}
					}
				}
			`,
			update: r => r.User.School
		}
	},
	watch: {
		School() {
			this.isMisAuthorisationRequired();
		}
	},
	methods: {
		async isMisAuthorisationRequired() {
			if (this.School && this.School.mis_identity === "scholarpack") {
				try {
					const result = await this.$apollo.mutate({
						mutation: gql`
							mutation {
								IsMisAuthorisationRequired
							}
						`
					});

					this.shouldShow = result.data.IsMisAuthorisationRequired;
				} catch (error) {
					console.log(error);
				}
			}
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/apps/appsList/cards/admin/UpgradeNotice.vue